<div *ngFor="let e of state.errors">{{ e }}</div>
<div *ngIf="state.loading">{{ state.loading }}</div>
